import React, { useEffect, useState } from 'react';
import { Table, Button, Image, Typography, Space, Input } from 'antd';
import axios from 'axios';
import config from '../../config';
import { toast } from 'react-toastify';
import { SearchOutlined } from '@ant-design/icons';
const { Text } = Typography;


const SelectCourseModal = ({ object, onSuccess, type }) => {

    const [courses, setCourses] = useState([]);
    const [initialized, setInitialized] = useState(false);
const [selectedMap, setSelectedMap] = useState(new Map());
    const [allCourses, setAllCourses] = useState([]);
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [selectedCourses, setSelectedCourses] = useState([]);
    const [btnStatus, setBtnStatus] = useState(true);
    const [loading, setLoading] = useState(false);
    const [pagination, setPagination] = useState({
        current: 1,
        pageSize: 8,
        total: 0,
    });

const [searchFilters, setSearchFilters] = useState({
        title: ""
    });

    const fetchCoursesWithFilter = async (page = pagination.current, pageSize = pagination.pageSize) => {
  try {
    setLoading(true);

    let dynamicFilter = "";
    if (searchFilters.title) {
      dynamicFilter += `title=*${searchFilters.title}/i`;
    }

    if (type === "user") {
      const userId = object.userID;

      const response = await axios.post(
        `${config.apiBaseUrl}/api/Course/getUserCourses`,
        userId,
        {
          params: {
            page,
            pageSize,
            filter: dynamicFilter,
          },
          headers: {
            "Content-Type": "application/json",
            HeaderKey: config.HeaderKey,
          },
          withCredentials: true,
        }
      );
      console.log(response.data)

      setCourses(response.data.data);
      setPagination(prev => ({
        ...prev,
        current: page,
        pageSize,
        total: response.data.count || 0,  // make sure backend sends count
      }));
    } else {
      const videoId = object.id;

      const response = await axios.post(
        `${config.apiBaseUrl}/api/video/getVideoCourses`,
        videoId,
        {
          params: {
            page,
            pageSize,
            filter: dynamicFilter,
          },
          headers: {
            "Content-Type": "application/json",
            HeaderKey: config.HeaderKey,
          },
          withCredentials: true,
        }
      );
      setCourses(response.data.data);
      setPagination(prev => ({
        ...prev,
        current: page,
        pageSize,
        total: response.data.count || 0,
      }));
    }
  } catch (error) {
    toast.error(<p dir="rtl" className="font-custom">جستجو با خطا مواجه شد</p>);
    if (error.response && error.response.status === 401) {
      toast.error(<p dir="rtl" className="font-custom">شما دسترسی انجام این عملیات را ندارید</p>);
    }
  } finally {
    setLoading(false);
  }
};

    const handleSearchChange = (e, columnName) => {


        let value = e.target.value;

        const newFilters = {
            ...searchFilters,
            [columnName]: value
        };


        setSearchFilters(newFilters);



        const filteredData = allCourses.filter(course => {
            
            return (
                (!newFilters.title || course.title.toLowerCase().includes(newFilters.title.toLowerCase()))
            );
        });

        setCourses(filteredData);

    };
    const handleSubmit = async () => {
        if(type === "user"){
            const userId = object.userID;
            try {
                const payload = {
                    userId: userId,
                    courseId: selectedRowKeys, 
                };
        
                const response = await axios.post(`${config.apiBaseUrl}/api/Course/AssignUserToCourse`, payload, {
                    headers: {
                        'Content-Type': 'application/json',
                        'HeaderKey': config.HeaderKey,
                    },
                    withCredentials: true,
                });
    
                if (response.data.success) {
                    toast.success(<p dir="rtl" className="font-custom">دسترسی به دوره ها بروز شد</p>);
    
                    onSuccess(); 
                } else {
                    console.error('Assignment failed:', response.data.message);
                }
            } catch (error) {
                console.error('Error assigning courses:', error);
            }
        }else{
            const videoId = object.id;
            try {
                const payload = {
                    videoId: videoId,
                    courseId: selectedRowKeys, 
                };
        
                const response = await axios.post(`${config.apiBaseUrl}/api/video/AssignVideoToCourse`, payload, {
                    headers: {
                        'Content-Type': 'application/json',
                        'HeaderKey': config.HeaderKey,
                    },
                    withCredentials: true,
                });
    
                if (response.data.success) {
                    if(type === "user"){
                        toast.success(<p dir="rtl" className="font-custom">دسترسی به دوره ها بروز شد</p>);
                    }else{
                        toast.success(<p dir="rtl" className="font-custom">ویدئو های دوره بروز شد</p>);
                    }
                    onSuccess();
                } else {
                    
                    toast.error(<p dir="rtl" className="font-custom">{response.data.message}</p>, { autoClose: 3000 });
                }
            } catch (error) {
                if (error.status === 414) {
                    toast.error(<p dir="rtl" className="font-custom">{error.response.data.error}</p>, { autoClose: 3000 });
                } else {
                    toast.error("خطا در برقراری ارتباط با سرور!", { autoClose: 3000 });
                }
            }
        }

    };
    

    const fetchCourses = async (page = 1, pageSize = 8) => {
        if(type === "user"){
            setLoading(true);
            const userId = object.userID;
            try {
    
                const response = await axios.post(`${config.apiBaseUrl}/api/Course/getUserCourses`,userId,{
                    params: { page, pageSize },
                    headers: {
                        "Content-Type": "application/json",
                        'HeaderKey': config.HeaderKey,
                    },
                    withCredentials: true,
                });

                
                const fetchedCourses = response.data.data || [];
                
                // Get IDs of courses with access
                const preselectedKeys = fetchedCourses
                    .filter((course) => course.hasAccess)
                    .map((course) => course.id);

                setCourses(fetchedCourses);
                setAllCourses(fetchedCourses);

                setSelectedRowKeys((prev) => {
                    const merged = Array.from(new Set([...(prev || []), ...preselectedKeys]));
                    return merged;
                });

                setSelectedMap((prev) => {
                    const next = new Map(prev);
                    fetchedCourses
                        .filter((course) => preselectedKeys.includes(course.id))
                        .forEach((course) => next.set(course.id, course));
                    setSelectedCourses(Array.from(next.values()));
                    return next;
                });

                if (!initialized) {
                    setInitialized(true);
                }
                setPagination((prev) => ({
                    ...prev,
                    current: page,
                    pageSize,
                    total: response.data.count || 0,
                }));
            } catch (err) {
                console.error('Error fetching courses:', err);
            } finally {
                setLoading(false);
            }
        }else{
            setLoading(true);
            const videoId = object.id;
            try {
    
                const response = await axios.post(`${config.apiBaseUrl}/api/video/getVideoCourses`,videoId,{
                    params: { page, pageSize },
                    headers: {
                        "Content-Type": "application/json",
                        'HeaderKey': config.HeaderKey,
                    },
                    withCredentials: true,
                });
                const fetchedCourses = response.data.data || [];
                // Get IDs of courses with access
                const preselectedKeys = fetchedCourses
                    .filter((course) => course.hasAccess)
                    .map((course) => course.id);
    
                    
                setCourses(fetchedCourses);
                setAllCourses(fetchedCourses);

                setSelectedRowKeys((prev) => {
                    const merged = Array.from(new Set([...(prev || []), ...preselectedKeys]));
                    return merged;
                });

                setSelectedMap((prev) => {
                    const next = new Map(prev);
                    fetchedCourses
                        .filter((course) => preselectedKeys.includes(course.id))
                        .forEach((course) => next.set(course.id, course));
                    setSelectedCourses(Array.from(next.values()));
                    return next;
                });

                if (!initialized) {
                    setInitialized(true);
                }
                setPagination((prev) => ({
                    ...prev,
                    current: page,
                    pageSize,
                    total: response?.data?.count ?? response?.data?.total ?? response?.data?.pagination?.total ?? 0,
                }));
            } catch (err) {
                console.error('Error fetching courses:', err);
            } finally {
                setLoading(false);
            }
        }
            
    };

    useEffect(() => {
        fetchCourses();
    }, []);

    const onSelectChange = (newSelectedRowKeys, selectedRows) => {
        setSelectedRowKeys(newSelectedRowKeys);

        setSelectedMap((prev) => {
            const next = new Map(prev);
            // add/update current page selections
            selectedRows.forEach(c => next.set(c.id, c));
            // remove anything that's no longer selected
            for (const key of Array.from(next.keys())) {
                if (!newSelectedRowKeys.includes(key)) next.delete(key);
            }
            setSelectedCourses(Array.from(next.values()));
            return next;
        });

        setBtnStatus(false);
    };

    const rowSelection = {
        selectedRowKeys,
        onChange: onSelectChange,
        preserveSelectedRowKeys: true,
    };

    const columns = [
        {
            dataIndex: 'imageUrl',
            key: 'imageUrl',
            align:'center',
            width:20,
            height:20,
            render: (url) => <Image width={60} height={40} src={config.apiBaseUrl + url} alt="Course" />,
        },
        {
            title: 'عنوان دوره',
            dataIndex: 'title',
            key: 'title',
            align:'right',
            className:'font-custom',
            filterDropdown: () => (
                <div style={{ padding: 8 }} className="font-custom">
                    <Space.Compact style={{ width: '100%' }}>
                        <Input
                            className="font-custom"
                            placeholder="جستجوی عنوان دوره"
                            allowClear
                            onClear={() => {
                                // Reset the search filter and re-fetch data
                                setSearchFilters((prevState) => ({
                                    ...prevState,
                                    title: "",
                                }));
                            }}
                            value={searchFilters.title}
                            onChange={(e) => {
                                handleSearchChange(e, "title");
                            }}
                            onPressEnter={() => {
                                fetchCoursesWithFilter();
                            }}
                        />
                        <Button type="primary"
                            icon={<SearchOutlined />}
                            onClick={() => {
                                // Server-side search when button is clicked
                                fetchCoursesWithFilter();
                            }}
                        />
                    </Space.Compact>
                </div>
            ),
            render: (text) => <Text strong>{text}</Text>,
        },
        {
            title: 'قیمت',
            dataIndex: 'price',
            key: 'price',
            align:'right',
            className:'font-custom ',
            render: (price) => <Text className='font-custom' dir='rtl'>{price.toLocaleString()} تومان </Text>,
        },
        {
            title: 'تعداد فایل‌ها',
            dataIndex: 'videoCount',
            key: 'videoCount',
            align:'center',
            className:'font-custom ',
        },
    ];
    return (
        <div className="font-custom">
            <Space direction="vertical" size="middle" style={{ width: '100%' }}>
                <Table
                    rowSelection={rowSelection}
                    columns={columns}
                    dataSource={courses}
                    rowKey="id"
                    className='font-custom'
                    loading={loading}
                    pagination={{
                        current: pagination.current,
                        pageSize: pagination.pageSize,
                        total: pagination.total,
                        onChange: (page, pageSize) => {
                            setPagination((prev) => ({ ...prev, current: page, pageSize }));
                            fetchCourses(page, pageSize);
                        },
                    }}
                />
                <div className='text-center'>
                    <Button
                        type="primary"
                        className="font-custom"
                        onClick={handleSubmit}
                        disabled={btnStatus}
                    >
                        ثبت تغییرات
                    </Button>
                </div>

                {selectedCourses.length > 0 && (
                    <div className="text-right">
                        <Text type="success" className='font-custom'>تعداد دوره انتخاب شده: {selectedCourses.length}</Text>
                    </div>
                )}
            </Space>
        </div>
    )
}

export default SelectCourseModal